import { render, staticRenderFns } from "./SankeyV2.vue?vue&type=template&id=b7c1d96e&scoped=true&"
import script from "./SankeyV2.vue?vue&type=script&lang=js&"
export * from "./SankeyV2.vue?vue&type=script&lang=js&"
import style0 from "./chart-content.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./sankey-v2.scss?vue&type=style&index=1&id=b7c1d96e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c1d96e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7c1d96e')) {
      api.createRecord('b7c1d96e', component.options)
    } else {
      api.reload('b7c1d96e', component.options)
    }
    module.hot.accept("./SankeyV2.vue?vue&type=template&id=b7c1d96e&scoped=true&", function () {
      api.rerender('b7c1d96e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Charts/SankeyV2/SankeyV2.vue"
export default component.exports